import { createAction } from 'redux-act';

const createPermissionRequest = createAction('CREATE_PERMISSION_REQUEST', data => data);
const createPermissionSuccess = createAction('CREATE_PERMISSION_SUCCESS', data => data);
const createPermissionError = createAction('CREATE_PERMISSION_ERROR');

const addAccessRouteRequest = createAction('ADD_ACCESS_ROUTE_REQUEST', data => data);
const addAccessRouteSuccess = createAction('ADD_ACCESS_ROUTE_SUCCESS', data => data);
const addAccessRouteError = createAction('ADD_ACCESS_ROUTE_ERROR');

const getAllRoutesRequest = createAction('GET_ALL_ROUTES_REQUEST', data => data);
const getAllRoutesSuccess = createAction('GET_ALL_ROUTES_SUCCESS', data => data);
const getAllRoutesError = createAction('GET_ALL_ROUTES_ERROR');

const getRoutesPermissionRequest = createAction('GET_ROUTES_PERMISSION_REQUEST', data => data);
const getRoutesPermissionSuccess = createAction('GET_ROUTES_PERMISSION_SUCCESS', data => data);
const getRoutesPermissionError = createAction('GET_ROUTES_PERMISSION_ERROR');

const getMenuPermissionRequest = createAction('GET_MENU_PERMISSION_REQUEST', data => data);
const getMenuPermissionSuccess = createAction('GET_MENU_PERMISSION_SUCCESS', data => data);
const getMenuPermissionError = createAction('GET_MENU_PERMISSION_ERROR');

const getMenuRoutesPermissionRequest = createAction('GET_MENU_ROUTES_PERMISSION_REQUEST', data => data);
const getMenuRoutesPermissionSuccess = createAction('GET_MENU_ROUTES_PERMISSION_SUCCESS', data => data);
const getMenuRoutesPermissionError = createAction('GET_MENU_ROUTES_PERMISSION_ERROR');

const getPermissionConstantRequest = createAction('GET_PERMISSION_CONSTANT_REQUEST', data => data);
const getPermissionConstantSuccess = createAction('GET_PERMISSION_CONSTANT_SUCCESS', data => data);
const getPermissionConstantError = createAction('GET_PERMISSION_CONSTANT_ERROR');

const getCategoryWisePermissionRequest = createAction('GET_CATEGORY_WISE_PERMISSION_REQUEST', data => data);
const getCategoryWisePermissionSuccess = createAction('GET_CATEGORY_WISE_PERMISSION_SUCCESS', data => data);
const getCategoryWisePermissionError = createAction('GET_CATEGORY_WISE_PERMISSION_ERROR');

const updatePermissionRequest = createAction('UPDATE_PERMISSION_REQUEST', data => data);
const updatePermissionSuccess = createAction('UPDATE_PERMISSION_SUCCESS', data => data);
const updatePermissionError = createAction('UPDATE_PERMISSION_ERROR');

const getRoleOrUserWisePermissionRequest = createAction('GET_ROLE_OR_USER_WISE_PERMISSION_REQUEST', data => data);
const getRoleOrUserWisePermissionSuccess = createAction('GET_ROLE_OR_USER_WISE_PERMISSION_SUCCESS', data => data);
const getRoleOrUserWisePermissionError = createAction('GET_ROLE_OR_USER_WISE_PERMISSION_ERROR');

const getNotificationEventRequest = createAction('GET_NOTIFICATION_EVENT_REQUEST', data => data);
const getNotificationEventSuccess = createAction('GET_NOTIFICATION_EVENT_SUCCESS', data => data);
const getNotificationEventError = createAction('GET_NOTIFICATION_EVENT_ERROR');

const updateCommunicationRequest = createAction('UPDATE_COMMUNICATION_REQUEST', data => data);
const updateCommunicationSuccess = createAction('UPDATE_COMMUNICATION_SUCCESS', data => data);
const updateCommunicationError = createAction('UPDATE_COMMUNICATION_ERROR');



// clear existing Designation action
const handleClearPermissionStore = createAction('HANDLE_PERMISSION_STORE',data => data);

export default {
    createPermissionRequest,
    createPermissionSuccess,
    createPermissionError,

    addAccessRouteRequest,
    addAccessRouteSuccess,
    addAccessRouteError,

    getAllRoutesRequest,
    getAllRoutesSuccess,
    getAllRoutesError,

    getRoutesPermissionRequest,
    getRoutesPermissionSuccess,
    getRoutesPermissionError,

    getMenuPermissionRequest,
    getMenuPermissionSuccess,
    getMenuPermissionError,

    getMenuRoutesPermissionRequest,
    getMenuRoutesPermissionSuccess,
    getMenuRoutesPermissionError,

    getPermissionConstantRequest,
    getPermissionConstantSuccess,
    getPermissionConstantError,

    getCategoryWisePermissionRequest,
    getCategoryWisePermissionSuccess,
    getCategoryWisePermissionError,

    updatePermissionRequest,
    updatePermissionSuccess,
    updatePermissionError,

    getRoleOrUserWisePermissionRequest,
    getRoleOrUserWisePermissionSuccess,
    getRoleOrUserWisePermissionError,

    getNotificationEventRequest,
    getNotificationEventSuccess,
    getNotificationEventError,

    updateCommunicationRequest,
    updateCommunicationSuccess,
    updateCommunicationError,
    
    handleClearPermissionStore,
}